/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAdminVoxtralAbortRolloverChannelPost } from '../fn/voxtral-admin/api-admin-voxtral-abort-rollover-channel-post';
import { ApiAdminVoxtralAbortRolloverChannelPost$Params } from '../fn/voxtral-admin/api-admin-voxtral-abort-rollover-channel-post';
import { apiAdminVoxtralChannelVersionsGet } from '../fn/voxtral-admin/api-admin-voxtral-channel-versions-get';
import { ApiAdminVoxtralChannelVersionsGet$Params } from '../fn/voxtral-admin/api-admin-voxtral-channel-versions-get';

@Injectable({ providedIn: 'root' })
export class VoxtralAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAdminVoxtralChannelVersionsGet()` */
  static readonly ApiAdminVoxtralChannelVersionsGetPath = '/api/admin/voxtral/channel-versions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminVoxtralChannelVersionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminVoxtralChannelVersionsGet$Response(params?: ApiAdminVoxtralChannelVersionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAdminVoxtralChannelVersionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminVoxtralChannelVersionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminVoxtralChannelVersionsGet(params?: ApiAdminVoxtralChannelVersionsGet$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminVoxtralChannelVersionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminVoxtralAbortRolloverChannelPost()` */
  static readonly ApiAdminVoxtralAbortRolloverChannelPostPath = '/api/admin/voxtral/abort-rollover/{channel}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminVoxtralAbortRolloverChannelPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminVoxtralAbortRolloverChannelPost$Response(params: ApiAdminVoxtralAbortRolloverChannelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAdminVoxtralAbortRolloverChannelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminVoxtralAbortRolloverChannelPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminVoxtralAbortRolloverChannelPost(params: ApiAdminVoxtralAbortRolloverChannelPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminVoxtralAbortRolloverChannelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
